import createVueComponent from '../createVueComponent';

const MousePointer2 = createVueComponent('MousePointer2Icon', [
  ['path', { d: 'm4 4 7.07 17 2.51-7.39L21 11.07z', key: '1vqm48' }],
]);

export default MousePointer2;
